import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as feedSelectors from 'services/feed/selectors'
import * as feedActions from 'services/feed/actions'
import * as userSelectors from 'services/user/selectors'
import Loader from 'components/util/Loader'
import Story from './Story'
import styles from './_feedStories.css'

const mapStateToProps = (state) => ({
  activityStories: feedSelectors.selectFilteredActivityStories(state),
  userId: userSelectors.selectUserId(state),
})

const mapDispatchToActions = {
  ...feedActions,
}

export class FeedStories extends Component {
  static propTypes = {
    activityStories: PropTypes.array,
    userId: PropTypes.number,
    getActivityFeed: PropTypes.func,
    likeStory: PropTypes.func,
    unlikeStory: PropTypes.func,
    postComment: PropTypes.func,
    deleteComment: PropTypes.func,
    deleteStory: PropTypes.func,
    getStoryComments: PropTypes.func,
    feedLoading: PropTypes.bool,
  }

  state = {
    feedLoading: true,
  }

  componentWillMount () {
    const { userId, getActivityFeed } = this.props
    getActivityFeed(userId, 'user').then(() => {
      this.setState({
        feedLoading: false,
      })
    }).catch(() => {
      this.setState({
        feedLoading: false,
      })
    })
  }

  handleOnLike = (storyId) => {
    const { userId, likeStory } = this.props
    likeStory(userId, storyId)
  }

  handleOnUnlike = (story) => {
    const { userId, unlikeStory } = this.props
    unlikeStory(userId, story)
  }

  handlePostComment = (text, storyId) => {
    return this.props.postComment(text, storyId)
  }

  handleDeleteComment = (commentId, storyId) => {
    return this.props.deleteComment(commentId, storyId)
  }

  handleDeleteStory = (storyId) => {
    return this.props.deleteStory(storyId)
  }

  handleGetStoryComments = (storyId) => {
    return this.props.getStoryComments(storyId)
  }

  render () {
    const { activityStories, userId } = this.props
    const { feedLoading } = this.state

    return (
      <div>
        {feedLoading ?
          <div className={styles.loading}>
            <Loader height={50} width={50} />
          </div>
        : null}
        {activityStories.map((story, i) => {
          return (
            <Story
              story={story}
              key={i}
              userId={userId}
              onLike={this.handleOnLike}
              onUnlike={this.handleOnUnlike}
              onPostComment={this.handlePostComment}
              onDeleteComment={this.handleDeleteComment}
              onDeleteStory={this.handleDeleteStory}
              onGetStoryComments={this.handleGetStoryComments}
            />
          )
        })}
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToActions)(FeedStories)



// WEBPACK FOOTER //
// ./src/components/home/feed/FeedStories.jsx